// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"b4976ed4","492":"15069f4f","787":"f584eeb2","946":"6abfdc41"}[chunkId] + ".chunk.js";
};